import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

export function Footer() {
    const { t } = useLang();
    return (
        <footer data-testid="site-footer" className="relative bg-obsidian text-white grain overflow-hidden">
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-24 pb-12 relative z-10">
                <div className="grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-6">
                        <div className="eyebrow text-cyan mb-6">{t.footer.tagline}</div>
                        <h2 className="font-heading font-black text-4xl sm:text-5xl leading-[0.95] tracking-tight max-w-xl">
                            {t.footer.feel.split("\n").map((l, i) => <span key={i} className="block">{l}</span>)}
                        </h2>
                        <Link
                            to="/contact"
                            data-testid="footer-cta"
                            className="eyebrow inline-flex items-center mt-10 rounded-full bg-cyan text-obsidian px-6 py-3 hover:-translate-y-0.5 transition-transform duration-300"
                        >
                            {t.cta.talkToTeam}
                        </Link>
                    </div>
                    <div className="lg:col-span-3">
                        <div className="eyebrow text-white/40 mb-5">{t.footer.explore}</div>
                        <ul className="space-y-3 text-white/70">
                            <li><Link to="/products" className="hover:text-cyan transition-colors">{t.nav.devices}</Link></li>
                            <li><Link to="/about" className="hover:text-cyan transition-colors">{t.nav.about}</Link></li>
                            <li><Link to="/contact" className="hover:text-cyan transition-colors">{t.nav.contact}</Link></li>
                            <li><Link to="/login" className="hover:text-cyan transition-colors">{t.auth.signIn}</Link></li>
                        </ul>
                    </div>
                    <div className="lg:col-span-3">
                        <div className="eyebrow text-white/40 mb-5">{t.footer.certified}</div>
                        <ul className="space-y-3 text-white/70 font-mono-tech text-sm">
                            <li>ISO 13485</li>
                            <li>ISO 9001</li>
                            <li>ISO 14971</li>
                            <li>GMP</li>
                        </ul>
                    </div>
                </div>

                <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <span className="inline-flex items-center bg-white rounded-md px-2.5 py-1.5"><img src="/korhc-logo.png?v=4" alt="KORHC" className="h-6 w-auto" /></span>
                    <p className="font-mono-tech text-xs text-white/40">{t.footer.rights}</p>
                </div>
            </div>
        </footer>
    );
}
